import { React } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { Link } from "react-router-dom";
const Header = ({ toggleDarkMode, isDarkMode }) => {
  return (
    <nav className="top-0 m-0 flex max-h-20 w-full flex-row items-center justify-between bg-light-primary-1 p-0 shadow-sm dark:bg-dark-primary-1 md:max-h-16">
      <div className="m-5 flex w-1/3 flex-row ">
        <div class="h-14 w-7 overflow-hidden text-5xl transition-[width] delay-75  md:hover:w-44 md:hover:cursor-pointer">
          <Link to="/">
            <span className=" text-light-secondary-1 dark:text-dark-primary-2 ">
              G
            </span>
            <span className="text-light-secondary-1 dark:text-dark-primary-2">
              autham
            </span>
          </Link>
        </div>
      </div>
      <div className="flex w-1/3 flex-row justify-end">
        <div className="w-1/2">
          <Link to="/resume">
            <div className="text-center font-google-lobster text-4xl font-medium text-light-secondary-1 hover:cursor-pointer hover:underline hover:underline-offset-4 dark:text-dark-primary-2">
              More
            </div>
          </Link>
        </div>
        <button
          onClick={toggleDarkMode}
          className="w-1/2 text-light-secondary-1 hover:cursor-pointer dark:text-dark-secondary-2"
        >
          {isDarkMode ? (
            <FaMoon className="text-lg" />
          ) : (
            <FaSun className="text-2xl" />
          )}
        </button>
      </div>
    </nav>
  );
};

export default Header;
